import React, { Component } from 'react'
import { connect } from 'react-redux'
import { translation } from '../../../../utils/helpers'
import Line from '../Line'
import AssessmentReportSums from '../AssessmentReportSums'

class CombinedPrice extends Component {
  constructor (props) {
    super(props)

    this.state = {
    }
  }

  componentDidMount () {
    if (!this.props.noRef) {
      this.props.onRef(this)
    }
  }

  componentWillUnmount () {
    if (!this.props.noRef) {
      this.props.onRef(undefined)
    }
  }

  getTitle () {
    if (this.props.orderPrice === null) return null
    if (this.props.orderPrice.IsAddonPrice) {
      return translation(1396)
    }
    switch (this.props.order.OrderType) {
      case 1:
        return translation(13360)
      case 2:
        return translation(71)
      case 3:
        return translation(13361)
      case 6:
        return translation(785)
    }
    return 'No title'
  }

  getIcon () {
    if (this.props.orderPrice === null) return null
    if (this.props.orderPrice.IsAddonPrice) {
      return '/images/svgs/taksering/Additional-sales-new.svg'
    }
    switch (this.props.order.OrderType) {
      case 1:
        return '/images/svgs/ordrer/Insurance-black.svg'
      case 2:
        return '/images/svgs/ordrer/Salescar-black.svg'
      case 3:
        return '/images/svgs/ordrer/Garanteed-black.svg'
      case 6:
        return '/images/svgs/ordrer/Private_c-black.svg'
    }
    return null
  }

  getTitleAria () {
    if (this.props.orderPrice === null) return null
    if (this.props.orderPrice.IsAddonPrice) {
      return translation(34) + ' ' + translation(1396)
    }
    return translation(2705)
  }

  renderAmountField (label, value, bold = false) {
    if (value === null) value = 0
    let amount = value
    return (
      <Line text={label} amount={amount} boldText={bold} bold={bold} currencyType={this.props.currencyCode} />
    )
  }

  renderManualAmounts () {
    const { order, viewMode } = this.props

    const hasPaintPriceList = order.HasBasePaintPriceList
    const isCorrectViewMode = viewMode !== 'simple'
    // let hasBodyPriceList = true

    const renderDivider = (text) => {
      if (text !== undefined) {
        return (
          <div className='title spacing'>{text}</div>
        )
      }
      return (
        <div className='h-line bold' />
      )
    }

    const addon = order.AddonPrice + order.AddonEnvironment + order.BodyShopAddonPrice + order.BodyShopAddonEnvironment
    const total = order.ManualBodyGross + order.Price + order.Environment + addon

    return (
      <div>
        {isCorrectViewMode && this.renderAmountField(translation(416), order.ManualBodyWorkPrice)}
        {isCorrectViewMode && this.renderAmountField(translation(15156), order.ManualBodyWorkEnvPrice)}
        {isCorrectViewMode && this.renderAmountField(translation(637), order.ManualBodySparePartPrice)}
        {isCorrectViewMode && this.renderAmountField(translation(15154), order.ManualBodyMiscPrice)}
        {isCorrectViewMode && !hasPaintPriceList && this.renderAmountField(translation(660), order.Price)}
        {isCorrectViewMode && !hasPaintPriceList && this.renderAmountField(translation(15155), order.Environment)}
        {isCorrectViewMode && this.renderAmountField(translation(1396), addon)}

        <div className='totals'>
          {isCorrectViewMode && renderDivider()}
          {this.renderAmountField(translation(17889), total, true)}
        </div>
      </div>
    )
  }

  renderReportSums () {
    // If bodyshop, we want to show both paint and body prices in this case.
    let department = this.props.department
    if (department === 1) {
      department = 2
    }

    return (
      <AssessmentReportSums report={this.props.order.Report} department={department} currencyCode={this.props.currencyCode} includeTotal includeTotalDivider />
    )
  }

  render () {
    const { editable, viewMode } = this.props

    if (editable) {
      console.error('CombinedPrice has no edit support!')
    }

    const css = 'manualbody'
    return (
      <div className={css}>
        {viewMode === 'mobile' && this.props.renderInside()}
        {this.props.order.Report ? this.renderReportSums() : this.renderManualAmounts()}
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    currencyCode: state.common.currencyCode
  }
}
export default connect(mapStateToProps, {})(CombinedPrice)



// WEBPACK FOOTER //
// ./src/app/shared/components/Extent/CombinedPrice/index.js